import { Box, Typography, Stack, Button } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { FormattedMessage } from 'react-intl';
import useAuth from 'hooks/useAuth';

// ==============================|| MAINTENANCE / REDIRECT FULL-PAGE SCREEN ||============================== //

const NEW_APP_URL = 'https://v3.checkinagency.com/';

const MaintenanceScreen = () => {
    const { logout } = useAuth() || {};

    const handleLogout = async () => {
        try {
            if (logout) await logout();
        } catch (e) {
            // ignore
        }
    };

    return (
        <Box
            sx={{
                position: 'fixed',
                inset: 0,
                width: '100vw',
                height: '100vh',
                bgcolor: '#fafafa',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2000,
                px: 3
            }}
        >
            <Stack spacing={3} alignItems="center" sx={{ maxWidth: 560, textAlign: 'center' }}>
                <Typography variant="h2">
                    <FormattedMessage
                        id="maintenanceTitle"
                        defaultMessage="L'application a déménagé"
                    />
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    <FormattedMessage
                        id="maintenanceMessage"
                        defaultMessage="Cette interface n'est plus utilisée. Merci de vous connecter désormais sur la nouvelle adresse :"
                    />
                </Typography>
                <Button
                    href={NEW_APP_URL}
                    variant="contained"
                    size="large"
                    endIcon={<OpenInNewIcon />}
                    sx={{ textTransform: 'none', fontSize: '1rem', px: 3 }}
                >
                    {NEW_APP_URL}
                </Button>
                <Typography
                    component="button"
                    onClick={handleLogout}
                    sx={{
                        mt: 2,
                        background: 'none',
                        border: 'none',
                        color: 'primary.main',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        fontSize: '0.9rem'
                    }}
                >
                    <FormattedMessage id="logout" defaultMessage="Se déconnecter" />
                </Typography>
            </Stack>
        </Box>
    );
};

export default MaintenanceScreen;
